/*! ****************************************************************************
Preact bindings for Small-Redux.
https://github.com/m18ru/preact-small-redux
***************************************************************************** */
import * as tslib_1 from "tslib";
import { Component } from 'preact';
function createSubscribedComponent(store) {
    var StoreSubscribedComponent = (function (_super) {
        tslib_1.__extends(StoreSubscribedComponent, _super);
        function StoreSubscribedComponent(props) {
            var _this = _super.call(this, props) || this;
            _this.storeStateChanged(store.getState());
            _this.dispatch = store.dispatch;
            var unsubscribe;
            var originalComponentDidMount = _this.componentDidMount;
            _this.componentDidMount = function componentDidMount() {
                var _this = this;
                unsubscribe = store.subscribe(function () { return _this.storeStateChanged(store.getState()); });
                if (originalComponentDidMount) {
                    originalComponentDidMount.call(this);
                }
            };
            var originalComponentWillUnmount = _this.componentWillUnmount;
            _this.componentWillUnmount = function componentWillUnmount() {
                if (unsubscribe) {
                    unsubscribe();
                    unsubscribe = undefined;
                }
                if (originalComponentWillUnmount) {
                    originalComponentWillUnmount.call(this);
                }
            };
            return _this;
        }
        return StoreSubscribedComponent;
    }(Component));
    return StoreSubscribedComponent;
}
export { createSubscribedComponent as default, };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/preact-small-redux/es5-esm/index.js
// module id = 8Q0Y
// module chunks = 3 10